module.exports = __webpack_public_path__ + "img/banner-transparent.3f2bcbc8.png";